/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Stamps_Work_List2Inputs */

const en_how_stamps_work_list2 = /** @type {(inputs: How_Stamps_Work_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use stamps to redeem missing cakes.`)
};

const ar_how_stamps_work_list2 = /** @type {(inputs: How_Stamps_Work_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استخدم الطوابع لاستبدال الكعكات المفقودة.`)
};

const de_how_stamps_work_list2 = /** @type {(inputs: How_Stamps_Work_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwende Stempel, um fehlende Kuchen einzulösen.`)
};

const es_how_stamps_work_list2 = /** @type {(inputs: How_Stamps_Work_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa sellos para canjear los pasteles que te falten.`)
};

const fr_how_stamps_work_list2 = /** @type {(inputs: How_Stamps_Work_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez les timbres pour obtenir les gâteaux manquants.`)
};

const it_how_stamps_work_list2 = /** @type {(inputs: How_Stamps_Work_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa i timbri per riscattare le torte mancanti.`)
};

const ja_how_stamps_work_list2 = /** @type {(inputs: How_Stamps_Work_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタンプを使って未獲得のケーキと交換できます。`)
};

const ko_how_stamps_work_list2 = /** @type {(inputs: How_Stamps_Work_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스탬프를 사용하여 수집하지 못한 케이크를 교환하세요.`)
};

const pt_br_how_stamps_work_list2 = /** @type {(inputs: How_Stamps_Work_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use selos para resgatar os bolos que faltam.`)
};

const ru_how_stamps_work_list2 = /** @type {(inputs: How_Stamps_Work_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Используйте штампы, чтобы получить недостающие торты.`)
};

const th_how_stamps_work_list2 = /** @type {(inputs: How_Stamps_Work_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช้แสตมป์เพื่อแลกรับเค้กที่ยังไม่มี`)
};

const tr_how_stamps_work_list2 = /** @type {(inputs: How_Stamps_Work_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksik pastaları almak için pulları kullanın.`)
};

const zh_cn_how_stamps_work_list2 = /** @type {(inputs: How_Stamps_Work_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你可以使用印花兑换尚未收藏的蛋糕。`)
};

const zh_tw_how_stamps_work_list2 = /** @type {(inputs: How_Stamps_Work_List2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你可以使用印花兌換尚未收藏的蛋糕。`)
};

/**
* | output |
* | --- |
* | "Use stamps to redeem missing cakes." |
*
* @param {How_Stamps_Work_List2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const how_stamps_work_list2 = /** @type {((inputs?: How_Stamps_Work_List2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Stamps_Work_List2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_how_stamps_work_list2(inputs)
	if (locale === "ar") return ar_how_stamps_work_list2(inputs)
	if (locale === "de") return de_how_stamps_work_list2(inputs)
	if (locale === "es") return es_how_stamps_work_list2(inputs)
	if (locale === "fr") return fr_how_stamps_work_list2(inputs)
	if (locale === "it") return it_how_stamps_work_list2(inputs)
	if (locale === "ja") return ja_how_stamps_work_list2(inputs)
	if (locale === "ko") return ko_how_stamps_work_list2(inputs)
	if (locale === "pt_br") return pt_br_how_stamps_work_list2(inputs)
	if (locale === "ru") return ru_how_stamps_work_list2(inputs)
	if (locale === "th") return th_how_stamps_work_list2(inputs)
	if (locale === "tr") return tr_how_stamps_work_list2(inputs)
	if (locale === "zh_cn") return zh_cn_how_stamps_work_list2(inputs)
	return zh_tw_how_stamps_work_list2(inputs)
});